import { useState } from "react";
import { Check, ChevronDown, ChevronUp, Copy, Play } from "lucide-react";

const LONG = 700;

// Phone-friendly prompt body: long prompts start collapsed (CSS only below md) with Show / Copy / Run actions.
export function CollapsiblePrompt({ body, idx, locked, copied, onCopy, children }) {
  const [expanded, setExpanded] = useState(false);
  const long = (body || "").length > LONG;
  const collapsed = long && !expanded && !locked;
  const runPrompt = () => {
    const btn = document.querySelector(`[data-testid="run-prompt-open-${idx}"]`);
    if (btn) { btn.click(); setTimeout(() => btn.closest("article")?.querySelector(`[data-testid="run-panel-${idx}"]`)?.scrollIntoView({ behavior: "smooth", block: "start" }), 50); }
  };
  return (
    <>
      <div className={`relative ${collapsed ? "max-md:max-h-[280px] max-md:overflow-hidden" : ""}`} data-testid={`prompt-body-wrap-${idx}`} data-collapsed={collapsed ? "true" : "false"}>
        <pre
          className={`font-mono text-sm md:text-base text-zinc-200 whitespace-pre-wrap leading-relaxed p-5 md:p-8 bg-[#070710] m-0 relative ${locked ? "blur-[3px] select-none" : ""}`}
          data-testid={`prompt-body-${idx}`}
          aria-hidden={locked || undefined}
        >
          {body}
        </pre>
        {children}
        {collapsed && <div className="pointer-events-none absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-[#070710] via-[#070710]/85 to-transparent md:hidden" aria-hidden="true" />}
      </div>
      {!locked && long && (
        <div className="grid grid-cols-3 gap-2 border-t border-zinc-900 bg-[#070710] px-3 py-3 md:hidden" data-testid={`prompt-mobile-actions-${idx}`}>
          <button type="button" onClick={() => setExpanded((v) => !v)} aria-expanded={!collapsed} className="inline-flex min-h-11 items-center justify-center gap-1.5 border border-zinc-700 px-2 text-xs font-bold uppercase tracking-wide text-zinc-200" data-testid={`prompt-toggle-${idx}`}>
            {collapsed ? <ChevronDown size={14} aria-hidden="true" /> : <ChevronUp size={14} aria-hidden="true" />}{collapsed ? "Show full" : "Collapse"}
          </button>
          <button type="button" onClick={onCopy} className="inline-flex min-h-11 items-center justify-center gap-1.5 border border-zinc-700 px-2 text-xs font-bold uppercase tracking-wide text-zinc-200" data-testid={`prompt-copy-mobile-${idx}`}>
            {copied ? <Check size={14} aria-hidden="true" /> : <Copy size={14} aria-hidden="true" />}{copied ? "Copied" : "Copy"}
          </button>
          <button type="button" onClick={runPrompt} className="inline-flex min-h-11 items-center justify-center gap-1.5 bg-purple-500 px-2 text-xs font-black uppercase tracking-wide text-black" data-testid={`prompt-run-mobile-${idx}`}>
            <Play size={14} aria-hidden="true" />Run
          </button>
        </div>
      )}
    </>
  );
}
